import { Popup, PopupBody, PopupFooter } from '../controls';

export interface UseOfProceedsPopupProps {
    issuer: string;
    useOfProceedsDescription: string;
    onClose: () => void;
}

export function UseOfProceedsPopup({ issuer, useOfProceedsDescription, onClose }: UseOfProceedsPopupProps) {
    return (
        <Popup
            modalClass="modal-issuer-description"
            title="Use of Proceeds Description"
            renderTitle={<span className="name-tag">{issuer}</span>}
            onClose={onClose}
            renderInBody
        >
            <PopupBody>
                <div
                    className="issuer-description-content"
                    dangerouslySetInnerHTML={{ __html: useOfProceedsDescription }}
                />
            </PopupBody>
            <PopupFooter>
                <button className="btn btn-ghost" onClick={onClose}>
                    Close
                </button>
            </PopupFooter>
        </Popup>
    );
}
